var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'ui-select': true,
        '--labelless': _vm.labelText === null,
        '--no-options': _vm.noOptions,
        '--gray': _vm.isGrayTheme,
        '--transparent': _vm.isTransparentTheme,
        disabled: _vm.disabled,
        unvalid: _vm.isUnvalid,
        focus: _vm.isFocus,
        contain: _vm.isContaining
    }},[_c('div',{staticClass:"ui-select__input"},[(_vm.labelText)?_c('label',[_vm._v(_vm._s(_vm.labelText))]):_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.options,"label":_vm.optionFieldKey,"placeholder":_vm.placeholder,"multiple":_vm.multiselect,"components":{ Deselect: _vm.Deselect, OpenIndicator: _vm.OpenIndicator },"clearable":_vm.isClearable,"value":_vm.selected,"searchable":false},on:{"input":_vm.updateSelected,"open":function($event){return _vm.setIsFocus(true)},"close":function($event){return _vm.setIsFocus(false)}},scopedSlots:_vm._u([{key:"no-options",fn:function(){return [_vm._v(_vm._s(_vm.textNoOptionsHandled))]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }